import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { access, apiErrorSchema } from './schemas/common.js';
import { scheduleDraftSchema, scheduleRunSchema, scheduledPromptSchema, } from './schemas/schedules.js';
const c = initContract();
const byId = z.object({ id: z.uuid() });
const invalid = apiErrorSchema.extend({ problems: z.array(z.string()) });
const one = z.object({ schedule: scheduledPromptSchema });
/**
 * Scheduled prompts, admins only: a schedule can send to every user, and its
 * answer is asked with its owner's reach. Nothing here runs a prompt — `run`
 * queues one for the bot, which answers and delivers within a tick.
 */
export const schedulesContract = c.router({
    list: {
        method: 'GET',
        metadata: access('admin'),
        path: '/schedules',
        responses: {
            200: z.object({
                schedules: z.array(scheduledPromptSchema),
                /** What a new schedule's timezone starts as, and every zone to choose from. */
                defaultTimezone: z.string(),
                timezones: z.array(z.string()),
            }),
        },
    },
    get: {
        method: 'GET',
        metadata: access('admin'),
        path: '/schedules/:id',
        pathParams: byId,
        responses: {
            200: z.object({ schedule: scheduledPromptSchema, runs: z.array(scheduleRunSchema) }),
            404: apiErrorSchema,
        },
    },
    add: {
        method: 'POST',
        metadata: access('admin'),
        path: '/schedules',
        body: scheduleDraftSchema,
        responses: { 201: one, 400: invalid },
    },
    /** The whole draft is replaced, and the next run worked out again. */
    update: {
        method: 'PUT',
        metadata: access('admin'),
        path: '/schedules/:id',
        pathParams: byId,
        body: scheduleDraftSchema,
        responses: { 200: one, 400: invalid, 404: apiErrorSchema },
    },
    toggle: {
        method: 'POST',
        metadata: access('admin'),
        path: '/schedules/:id/toggle',
        pathParams: byId,
        body: z.object({}),
        responses: { 200: one, 404: apiErrorSchema },
    },
    /** 202: queued. The bot runs it on its next tick. 409: the schedule is off. */
    run: {
        method: 'POST',
        metadata: access('admin'),
        path: '/schedules/:id/run',
        pathParams: byId,
        body: z.object({}),
        responses: { 202: one, 404: apiErrorSchema, 409: apiErrorSchema },
    },
    remove: {
        method: 'DELETE',
        metadata: access('admin'),
        path: '/schedules/:id',
        pathParams: byId,
        body: z.object({}),
        responses: { 200: z.object({}), 404: apiErrorSchema },
    },
});
//# sourceMappingURL=schedules.contract.js.map